import useCurrentMerchant from 'hooks/useCurrentMerchant'
import Cookie from 'js-cookie'
import { useCallback, useEffect, useState } from 'react'

const DISMISS_DURATION_MS = 24 * 60 * 60 * 1000

export default function useGrantedRewardExpirationNagDismissal(): [
  boolean,
  () => void
] {
  const merchant = useCurrentMerchant()
  const cookieName = merchant?.id
    ? `granted_reward_expiration_nag_dismissed_${merchant.id}`
    : null

  const [isDismissed, setIsDismissed] = useState(() =>
    cookieName ? Cookie.get(cookieName) === 'true' : false
  )

  // Re-sync dismissed state from the cookie whenever the merchant changes.
  useEffect(() => {
    setIsDismissed(cookieName ? Cookie.get(cookieName) === 'true' : false)
  }, [cookieName])

  const dismiss = useCallback(() => {
    if (!cookieName) return
    Cookie.set(cookieName, 'true', {
      expires: new Date(Date.now() + DISMISS_DURATION_MS),
      path: '/',
      secure:
        process.env.NODE_ENV !== 'development' &&
        process.env.NODE_ENV !== 'test',
    })
    setIsDismissed(true)
  }, [cookieName])

  return [isDismissed, dismiss]
}
